(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-main"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('[data-pdp-thumb]');
      if (thumb) {
        var src = thumb.getAttribute('data-pdp-thumb');
        var mainImg = document.getElementById('pdp-main-img');
        if (mainImg && src) {
          mainImg.style.opacity = '0';
          setTimeout(function() {
            mainImg.src = src;
            mainImg.style.opacity = '1';
          }, 150);
        }
        thumb.parentNode.querySelectorAll('.pdp__thumb').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }

      var qtyDown = e.target.closest('[data-qty-down]');
      var qtyUp = e.target.closest('[data-qty-up]');
      if (qtyDown || qtyUp) {
        var input = (qtyDown || qtyUp).parentNode.querySelector('[data-qty-input]');
        if (input) {
          var val = parseInt(input.value) || 1;
          input.value = qtyDown ? Math.max(1, val - 1) : val + 1;
        }
      }

      var optBtn = e.target.closest('.pdp__option-value');
      if (optBtn) {
        optBtn.parentNode.querySelectorAll('.pdp__option-value').forEach(function(b) { b.classList.remove('is-active'); });
        optBtn.classList.add('is-active');
      }
    });

    document.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-pdp-form]');
      if (!form) return;
      e.preventDefault();

      var formData = new FormData(form);
      var btn = form.querySelector('.pdp__add-btn');
      var origText = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Ekleniyor...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.id) {
          var cartOpen = document.querySelector('[data-cart-open]');
          if (cartOpen) cartOpen.click();
          if (btn) {
            btn.textContent = '✓ Eklendi';
            setTimeout(function() { btn.textContent = origText; }, 1500);
          }
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
          });
        } else {
          if (btn) btn.textContent = origText;
          alert(data.description || 'Bir hata oluştu.');
        }
      })
      .catch(function() {
        if (btn) btn.textContent = origText;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-reels]').forEach(function(root) {
      var track = root.querySelector('[data-reels-track]');
      var prev  = root.querySelector('[data-reels-prev]');
      var next  = root.querySelector('[data-reels-next]');
      if (!track || !prev || !next) return;

      function step() {
        var item = track.querySelector('.reels__item');
        if (!item) return 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        return item.getBoundingClientRect().width + gap;
      }

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      function updateNav() {
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;
        if (!hasOverflow) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
      setTimeout(updateNav, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.related-section').forEach(function(root) {
      var row = root.querySelector('[data-rel-row]');
      var prev = root.querySelector('[data-rel-prev]');
      var next = root.querySelector('[data-rel-next]');
      if (!row || !prev || !next) return;

      function step() {
        var cell = row.querySelector('.related-section__cell');
        if (!cell) return 0;
        var gap = parseFloat(getComputedStyle(row).gap) || 16;
        return cell.getBoundingClientRect().width + gap;
      }

      prev.addEventListener('click', function() {
        row.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        row.scrollBy({ left: step() * 2, behavior: 'smooth' });
      });

      function updateNav() {
        var hasOverflow = row.scrollWidth > row.clientWidth + 2;
        if (!hasOverflow) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = row.scrollLeft <= 2;
        next.hidden = row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
      }

      row.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
      setTimeout(updateNav, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
